import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileFormatPipe } from './mobile-format.pipe';

@NgModule({
  declarations: [MobileFormatPipe], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [MobileFormatPipe], // ✅ Export the pipe for use in other modules
})
export class MobileFormatPipeModule {}
